// extracted by mini-css-extract-plugin
export default {"QuizChooseItem":"QuizChooseItems_QuizChooseItem__cR9iE","wrapper":"QuizChooseItems_wrapper__6ea6y","wrapperMobile":"QuizChooseItems_wrapperMobile__gYY1h"};